<template>
  <div class="box">
    <dl>
      <dt>イベント名</dt>
      <dd>{{ eventData.name }}</dd>
      <dt>開催日時</dt>
      <dd>{{ eventData.date }}</dd>
      <dt>会場</dt>
      <dd>{{ eventData.place }}</dd>
    </dl>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EventSimpleBox',
  props: {
    eventData: {
      type: Object,
      default: () => ({})
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.box {
  margin-top: 30px;
  background-color: var.$color-other-bg;
  padding: 16px;
  dl {
    display: grid;
    grid-template-columns: 67px 1fr;
    gap: 6px 16px;
    font-size: 1.3rem;
    line-height: 1.5;
    letter-spacing: 0.03em;
    @include mixins.media() {
      font-size: 1.4rem;
      grid-template-columns: 73px 1fr;
      gap: 10px 34px;
    }
    dt {
      font-weight: 500;
    }
  }
}

.card {
  width: 100%;
  height: 100%;
  border: solid 1px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  border: 0.5px solid var.$color-border-gray;
  background-color: var.$color-white;

  &.isOnline {
    .head {
      background-color: #36c0f2;
    }
  }
  &.isOffline {
    .head {
      background-color: var.$color-primary;
    }
  }
  &.isCareer {
    .head {
      background-color: var.$color-main;
    }
  }
}

.cardContent {
  height: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 20px 24px;
}

.content {
  font-size: 13px;
  display: flex;
  flex-direction: column;
  > * {
    margin-bottom: 8px;
  }
}

.head {
  background-color: var.$color-main;
  color: var.$color-white;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 22px;
  padding: 5px 0;
  font-weight: bold;
  height: 32px;
  letter-spacing: 0;
  img {
    height: 13px;
    margin-right: 4px;
  }
}

.title {
  h3 {
    font-size: 18px;
    font-weight: 500;
    line-height: 2.2rem;
  }
  div {
    min-width: 70px;
    margin-left: 24px;
  }
  img {
    width: 70px;
    object-fit: contain;
  }
  display: flex;
  justify-content: space-between;
}

.eventType {
  display: flex;
  flex-wrap: wrap;
  span {
    background-color: var.$color-accent-back;
    padding: 0 5px;
    font-size: 1rem;
    line-height: 18px;
    font-weight: 500;
    margin-right: 8px;
    margin-bottom: 4px;
    &.isOnline {
      background-color: #36c0f2;
      color: #fff;
    }
    &.isOffline {
      background-color: var.$color-primary;
      color: #fff;
    }
    &.isCareer {
      background-color: var.$color-main;
      color: #fff;
    }
  }
}
.eventTypeContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .eventType {
    flex: 1;
  }
  .imgWrap {
    flex-basis: 70px;
  }
  img {
    width: 70px;
    object-fit: contain;
  }
}

.split {
  display: flex;
  dt {
    min-width: 30px;
    font-weight: 500;
  }
  dd {
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-left: 24px;
  }
}

.tags {
  display: flex;
  flex-wrap: wrap;
  > * {
    margin-right: 4px;
    margin-bottom: 4px;
  }
}

.desc {
  letter-spacing: 0.02px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.finishedText {
  height: 40px;
  margin-top: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  border-radius: 4px;
  background: #f5f5f5;
}

::v-deep .button {
  min-height: 40px;
  margin-top: 12px;
}

::v-deep .button + .button,
::v-deep .finishedText + .button {
  margin-top: 16px;
}
</style>
